import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLegalDocument, LegalDocumentId } from './legalContent';

interface LegalPageProps {
  documentId: LegalDocumentId;
}

const LegalPage: React.FC<LegalPageProps> = ({ documentId }) => {
  const { i18n, t } = useTranslation();
  const doc = getLegalDocument(documentId, i18n.language || 'zh');

  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900">{doc.title}</h1>
        <p className="mt-2 text-sm text-gray-500">{doc.lastUpdated}</p>
        <div className="mt-8 space-y-8">
          {doc.sections.map((section) => (
            <section key={section.heading}>
              <h2 className="text-xl font-semibold text-gray-900">{section.heading}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph.slice(0, 40)} className="mt-3 text-gray-700 leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </section>
          ))}
        </div>
        <nav className="mt-12 pt-6 border-t border-gray-200 flex flex-wrap gap-4 text-sm">
          <Link to="/terms" className="text-indigo-600 hover:text-indigo-500">
            {t('footer.terms')}
          </Link>
          <Link to="/disclaimer" className="text-indigo-600 hover:text-indigo-500">
            {t('footer.disclaimer')}
          </Link>
          <Link to="/safety" className="text-indigo-600 hover:text-indigo-500">
            {t('footer.safety')}
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default LegalPage;
